import {
  SAVE_SHAREDMAILBOXES,
  DELETE_SM_DONE,
  DELETE_SM_FAILED,
  DELETE_CHAT_INBOX_FAILED,
  DELETE_CHAT_INBOX_DONE,
  DELETE_VOICE_INBOX_FAILED,
  DELETE_VOICE_INBOX_DONE,
} from '../actions';

import { UPDATE_SM_DONE, UPDATE_SLA_DONE} from '../../common/actions';
import { getSortedUsersWithAvatarColors, showMessage } from 'h-commons';
import {getAutoResp} from '../../autoResponder/reducers';
import { GET_AUTORESP_DATA } from '../../autoResponder/actions/types';
import { TOGGLE_DOMAIN_COLLABORATION } from '../../permalink/actions/actionTypes';
import { SET_SM_PROPERTY } from '../../common/actions/types'

const initialState = {};



const getSmEmailId = (sm) => {
    const { gagroupemail, sourceuser, source, active, isgagroup } = sm;
    const isSmActive = parseInt(active);
    const isGaGroup = parseInt(isgagroup);
    if (!isGaGroup && isSmActive === 1) {
        if (!sourceuser) {
            return source.email;
        }
        return sourceuser.email;
    }
    return gagroupemail;
};

const setSharingSettingInStore = (store, smId,  settingName, enabled) => {
    return {
        ...store,
        [smId]:{
            ...store[smId],
            sharing: {
            ...(store[smId].sharing || {}),
                [settingName]: enabled
            },
        }
    }
}

const updateSmProperty = (store, payload) => {
  const {smId, property, value} = payload
  if (!store[smId]) // If no sm data is fetched yet, return without updating store
    return store;

  return {
    ...store,
    [smId]:{
        ...store[smId],
      [property]:value,
      smProperties: {
        ...(store?.[smId]?.["smProperties"] || {}),
        [property]: value
      }
    }
  }
}


/**
 * Saves all sm's of the UG
 * @param {Object} state Default empty state
 * @param {Object} action Action dispached from AC
 */
const allSharedMailboxReducer = (state = initialState, action) => {

    switch (action.type) {
      case SAVE_SHAREDMAILBOXES: {
        const newState = {};
        const { payload } = action;
        // Update Smlist without overriding existing Sm data.
        Object.keys(payload).forEach(
          (smId) => (newState[smId] = { ...(state[smId] || {}), ...payload[smId] })
        );
        return newState;
      }
      case UPDATE_SM_DONE: {
        const { id, smUsersList } = action.payload;
        const modAllSm = { ...state };
        if (id in state) {
          modAllSm[id] = { ...modAllSm[id], ...action.payload };
          if (smUsersList && Array.isArray(smUsersList)) {
            modAllSm[id]['smUsersList'] =
              getSortedUsersWithAvatarColors(smUsersList);
            modAllSm[id]['smEmailId'] = getSmEmailId(action.payload);
          }
        }
        return { ...state, ...modAllSm };
      }
      case DELETE_SM_DONE: {
        const newState = { ...state };
        if (newState.hasOwnProperty(action.payload)) {
          const sm_name = newState[action.payload].display_name;
          newState[action.payload].active = 0;
          showMessage({
            message: `${sm_name} is being deleted. This will take a few minutes.`,
            type: 'success',
          });
        }
        return newState;
      }

      case DELETE_CHAT_INBOX_DONE: {
        const newState = { ...state };
        const inbox_name = state[`chat_${action.payload}`].display_name;
        delete newState[`chat_${action.payload}`];
        showMessage({
          message: `Chat inbox ${inbox_name} has been deleted`,
          type: 'success',
        });
        return newState;
      }

      case DELETE_VOICE_INBOX_DONE: {
        const newState = { ...state };
        const voiceBox_name = state[`voice_${action.payload}`].display_name;
        delete newState[`voice_${action.payload}`];
        showMessage({
          message: `Voice inbox ${voiceBox_name} has been deleted`,
          type: 'success',
        });
        return newState;
      }

      case UPDATE_SLA_DONE: {
        const modAllSm = { ...state };
        const { smid, slaId, type, sla } = action.payload;
        if (smid in state) {
          let allSlas = modAllSm[smid]['sla'];
          if (type === 'delete') {
            const newSla = allSlas.filter((eachSla) => eachSla.id !== slaId);
            modAllSm[smid]['sla'] = newSla;
          } else if (type === 'update') {
            allSlas.map((eachSla, index) => {
              if (eachSla.id == slaId) {
                allSlas[index] = sla;
              }
              return allSlas;
            });
            modAllSm[smid]['sla'] = allSlas;
          } else if (type === 'create') {
            if (!Array.isArray(allSlas)) {
              allSlas = [];
            }
            allSlas.push(sla);
            modAllSm[smid]['sla'] = allSlas;
          }
        }
        return { ...state, ...modAllSm };
      }
      case DELETE_SM_FAILED:
        const sm_name = state[action.payload].display_name;
        showMessage({
          message: `Failed to delete ${sm_name}. Please try again`,
          type: 'error',
        });
        return state;

      case DELETE_CHAT_INBOX_FAILED:
        const inbox_name = state[`chat_${action.payload}`].display_name;
        showMessage({
          message: `Failed to delete ${inbox_name}. Please try again`,
          type: 'error',
        });
        return state;

      case DELETE_VOICE_INBOX_FAILED:
        console.log(
          'state[`voice_${action.payload}`]',
          state[`voice_${action.payload}`]
        );
        const voiceBox_name = state[`voice_${action.payload}`].display_name;
        showMessage({
          message: `Failed to delete ${voiceBox_name}. Please try again`,
          type: 'error',
        });
        return state;

      case GET_AUTORESP_DATA:
        const { smid } = action.payload;
        const thisSM = state[smid];
        return {
          ...state,
          [smid]: { ...thisSM, autoRespData: getAutoResp(null, action) },
        };

      case `${TOGGLE_DOMAIN_COLLABORATION}_SUCCESS`: {
        const { enabled, smId } = action.payload;
        return setSharingSettingInStore(
          state,
          smId,
          'external_collaboration_enabled',
          enabled
        );
      }
      case `${SET_SM_PROPERTY}_SUCCESS`: {
        return updateSmProperty(
          state,
          action.payload
        );
      }
      default:
        return state;
    }
}


export { allSharedMailboxReducer } 
